export const FILE_DOWNLOAD_REQUEST = 'FILE_DOWNLOAD_REQUEST'
export const FILE_DOWNLOAD_SUCCESS = 'FILE_DOWNLOAD_SUCCESS'
export const FILE_DOWNLOAD_FAIL = 'FILE_DOWNLOAD_FAIL'
export const FILE_DOWNLOAD_RESET = 'FILE_DOWNLOAD_RESET'

export const FILE_DOWNLOAD_ALL_REQUEST = 'FILE_DOWNLOAD_ALL_REQUEST'
export const FILE_DOWNLOAD_ALL_SUCCESS = 'FILE_DOWNLOAD_ALL_SUCCESS'
export const FILE_DOWNLOAD_ALL_FAIL = 'FILE_DOWNLOAD_ALL_FAIL'
export const FILE_DOWNLOAD_ALL_RESET = 'FILE_DOWNLOAD_ALL_RESET'
